import {
  GET_FOLLOWUPLIST,
  GET_FOLLOWUPLIST_SUCCESS,
  GET_FOLLOWUPLIST_FAIL,
  DELETE_FOLLOWUPLIST,
  DELETE_FOLLOWUPLIST_SUCCESS,
  DELETE_FOLLOWUPLIST_FAIL,
  UPDATE_FOLLOWUPLIST,
  UPDATE_FOLLOWUPLIST_SUCCESS,
  UPDATE_FOLLOWUPLIST_FAIL,
  ADD_NEW_FOLLOWUPLIST,
  ADD_FOLLOWUPLIST_SUCCESS,
  ADD_FOLLOWUPLIST_FAIL,
  FOLLOWUPLIST_LOADING,
  FOLLOWUPLIST_RESET
} from "./actionType";

export const resetFollowupListState = (actionType) => ({
  type: FOLLOWUPLIST_RESET,
  payload: { actionType },
});

export const getFollowupListSuccess = (actionType, data) => ({
  type: GET_FOLLOWUPLIST_SUCCESS,
  payload: { actionType, data },
});

export const getFollowupListFail = (actionType, error) => ({
  type: GET_FOLLOWUPLIST_FAIL,
  payload: { actionType, error },
});

export const getFollowupList = data => ({
  type: GET_FOLLOWUPLIST,
  payload: data,
});

export const getFollowupListLoading = () => ({
  type: FOLLOWUPLIST_LOADING
});

export const deleteFollowupList = data => ({
  type: DELETE_FOLLOWUPLIST,
  payload: data,
});

export const deleteFollowupListSuccess = data => ({
  type: DELETE_FOLLOWUPLIST_SUCCESS,
  payload: data,
});

export const deleteFollowupListFail = error => ({
  type: DELETE_FOLLOWUPLIST_FAIL,
  payload: error,
});

export const updateFollowupList = data => ({
  type: UPDATE_FOLLOWUPLIST,
  payload: data,
});

export const updateFollowupListFail = error => ({
  type: UPDATE_FOLLOWUPLIST_FAIL,
  payload: error,
});

export const updateFollowupListSuccess = data => ({
  type: UPDATE_FOLLOWUPLIST_SUCCESS,
  payload: data,
});

export const addNewFollowupList = data => ({
  type: ADD_NEW_FOLLOWUPLIST,
  payload: data,
});

export const addFollowupListSuccess = data => ({
  type: ADD_FOLLOWUPLIST_SUCCESS,
  payload: data,
});

export const addFollowupListFail = error => ({
  type: ADD_FOLLOWUPLIST_FAIL,
  payload: error,
});